"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BUSINESS_CHECKING_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.BUSINESS_CHECKING_ACCOUNT;
  }
});
Object.defineProperty(exports, "CARD_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.CARD_ACCOUNT;
  }
});
Object.defineProperty(exports, "CARD_PRODUCT", {
  enumerable: true,
  get: function () {
    return _constants.CARD_PRODUCT;
  }
});
Object.defineProperty(exports, "CROSS_BORDER_PAYMENTS", {
  enumerable: true,
  get: function () {
    return _constants.CROSS_BORDER_PAYMENTS;
  }
});
Object.defineProperty(exports, "CRYPTO_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.CRYPTO_ACCOUNT;
  }
});
Object.defineProperty(exports, "INVESTMENT_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.INVESTMENT_ACCOUNT;
  }
});
Object.defineProperty(exports, "KABBAGE_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.KABBAGE_ACCOUNT;
  }
});
Object.defineProperty(exports, "KABBAGE_BCA", {
  enumerable: true,
  get: function () {
    return _constants.KABBAGE_BCA;
  }
});
Object.defineProperty(exports, "KABBAGE_INSIGHTS", {
  enumerable: true,
  get: function () {
    return _constants.KABBAGE_INSIGHTS;
  }
});
Object.defineProperty(exports, "KABBAGE_LOC", {
  enumerable: true,
  get: function () {
    return _constants.KABBAGE_LOC;
  }
});
Object.defineProperty(exports, "KABBAGE_PAYMENTS", {
  enumerable: true,
  get: function () {
    return _constants.KABBAGE_PAYMENTS;
  }
});
Object.defineProperty(exports, "PERSONAL_CHECKING_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.PERSONAL_CHECKING_ACCOUNT;
  }
});
Object.defineProperty(exports, "PERSONAL_SAVINGS_ACCOUNT", {
  enumerable: true,
  get: function () {
    return _constants.PERSONAL_SAVINGS_ACCOUNT;
  }
});
Object.defineProperty(exports, "configureProductDucks", {
  enumerable: true,
  get: function () {
    return _config.configureProductDucks;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "getCustomerProductMarkets", {
  enumerable: true,
  get: function () {
    return _selectors.getCustomerProductMarkets;
  }
});
Object.defineProperty(exports, "getDefaultTypes", {
  enumerable: true,
  get: function () {
    return _selectors.getDefaultTypes;
  }
});
Object.defineProperty(exports, "getFilterTypes", {
  enumerable: true,
  get: function () {
    return _selectors.getFilterTypes;
  }
});
Object.defineProperty(exports, "getOrderTypes", {
  enumerable: true,
  get: function () {
    return _selectors.getOrderTypes;
  }
});
Object.defineProperty(exports, "getProduct", {
  enumerable: true,
  get: function () {
    return _selectors.getProduct;
  }
});
Object.defineProperty(exports, "getProductAccountKey", {
  enumerable: true,
  get: function () {
    return _selectors.getProductAccountKey;
  }
});
Object.defineProperty(exports, "getProductDetailsById", {
  enumerable: true,
  get: function () {
    return _selectors.getProductDetailsById;
  }
});
Object.defineProperty(exports, "getProductDetailsErrors", {
  enumerable: true,
  get: function () {
    return _selectors.getProductDetailsErrors;
  }
});
Object.defineProperty(exports, "getProductId", {
  enumerable: true,
  get: function () {
    return _selectors.getProductId;
  }
});
Object.defineProperty(exports, "getProductRegistryById", {
  enumerable: true,
  get: function () {
    return _selectors.getProductRegistryById;
  }
});
Object.defineProperty(exports, "getProductRegistryErrors", {
  enumerable: true,
  get: function () {
    return _selectors.getProductRegistryErrors;
  }
});
Object.defineProperty(exports, "getProductSortedIndex", {
  enumerable: true,
  get: function () {
    return _selectors.getProductSortedIndex;
  }
});
Object.defineProperty(exports, "getProducts", {
  enumerable: true,
  get: function () {
    return _selectors.getProducts;
  }
});
Object.defineProperty(exports, "getProductsByTypes", {
  enumerable: true,
  get: function () {
    return _selectors.getProductsByTypes;
  }
});
Object.defineProperty(exports, "getProductsOrder", {
  enumerable: true,
  get: function () {
    return _selectors.getProductsOrder;
  }
});
Object.defineProperty(exports, "getProductsRegistry", {
  enumerable: true,
  get: function () {
    return _selectors.getProductsRegistry;
  }
});
Object.defineProperty(exports, "getProductsRegistryMap", {
  enumerable: true,
  get: function () {
    return _selectors.getProductsRegistryMap;
  }
});
Object.defineProperty(exports, "getSelectedProduct", {
  enumerable: true,
  get: function () {
    return _selectors.getSelectedProduct;
  }
});
Object.defineProperty(exports, "getSelectedProductDetails", {
  enumerable: true,
  get: function () {
    return _selectors.getSelectedProductDetails;
  }
});
Object.defineProperty(exports, "getSelectedProductRegistry", {
  enumerable: true,
  get: function () {
    return _selectors.getSelectedProductRegistry;
  }
});
Object.defineProperty(exports, "injectCardProductData", {
  enumerable: true,
  get: function () {
    return _ducks.injectCardProductData;
  }
});
Object.defineProperty(exports, "injectCustomerProductDetails", {
  enumerable: true,
  get: function () {
    return _ducks.injectCustomerProductDetails;
  }
});
Object.defineProperty(exports, "injectProductDetailsErrors", {
  enumerable: true,
  get: function () {
    return _ducks.injectProductDetailsErrors;
  }
});
Object.defineProperty(exports, "loadProducts", {
  enumerable: true,
  get: function () {
    return _ducks.loadProducts;
  }
});
Object.defineProperty(exports, "loadProductsRegistry", {
  enumerable: true,
  get: function () {
    return _ducks.loadProductsRegistry;
  }
});
Object.defineProperty(exports, "queryProducts", {
  enumerable: true,
  get: function () {
    return _ducks.queryProducts;
  }
});
Object.defineProperty(exports, "queryProductsRegistry", {
  enumerable: true,
  get: function () {
    return _ducks.queryProductsRegistry;
  }
});
Object.defineProperty(exports, "readCustomerProductDetailsV1", {
  enumerable: true,
  get: function () {
    return _readCustomerProductDetailsV.default;
  }
});
Object.defineProperty(exports, "readCustomerProductsV2", {
  enumerable: true,
  get: function () {
    return _readCustomerProductsV.default;
  }
});
Object.defineProperty(exports, "selectProduct", {
  enumerable: true,
  get: function () {
    return _ducks.selectProduct;
  }
});
Object.defineProperty(exports, "selectProductByKey", {
  enumerable: true,
  get: function () {
    return _ducks.selectProductByKey;
  }
});
var _config = require("./config");
var _ducks = _interopRequireWildcard(require("./ducks"));
var _selectors = require("./selectors");
var _constants = require("./constants");
var _readCustomerProductsV = _interopRequireDefault(require("./resources/readCustomerProductsV2"));
var _readCustomerProductDetailsV = _interopRequireDefault(require("./resources/readCustomerProductDetailsV1"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = _ducks.default;
exports.default = _default;